module.exports = __webpack_public_path__ + "img/requisitos-title.6f2510a5.svg";